export const baseUrl = 'ws://120.26.42.204:8083/mqtt';
export const subscribeMessageApi = '/vehicle/topple/fall/message';
export const publishMessageApi = '/com/cfmoto/risk';
